<!-- How It Works Section Begin -->
<section class="howit-works spad">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title">
            <span>{{ 'CCA.SUBTITLE' | translate }}</span>
            <h2>{{ 'CCA.TITLE' | translate }}</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="single-howit-works">
            <img src="./assets/img/howit-works/howit-works-1.png" alt="">
            <h4>{{ 'CCA.BROWSE.TITLE' | translate }}</h4>
            <p>{{ 'CCA.BROWSE.DESCRIPTION' | translate }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="single-howit-works">
            <img src="./assets/img/howit-works/howit-works-2.png" alt="">
            <h4>{{ 'CCA.VISIT.TITLE' | translate }}</h4>
            <p>{{ 'CCA.VISIT.DESCRIPTION' | translate }}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="single-howit-works">
            <img src="./assets/img/howit-works/howit-works-3.png" alt="">
            <h4>{{ 'CCA.VALIDATE.TITLE' | translate }}</h4>
            <p>{{ 'CCA.VALIDATE.DESCRIPTION' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- How It Works Section End -->